import { useNavigate } from "react-router-dom"
import { IndorImages, getIndorImageSrc } from "../../../../features"
import { useAppSelector } from "../../../../stateManagement/hooks/redux"
import { ContentHeaderButton } from "../../contentHeaderButton"
import { useEffect, useState } from "react"
import { PanoramaFilters } from "../../../panoramaFilters"
import { controlCopyCoordsButton, controlMapSettingsButton, controlNavigateToMapButton, controlPanoramaFilterButton, controlSearchLineButton } from "./widgetsFunctions"

const panoramaFilterButtonIconSrc = require('../../../../assets/images/fontAwesomeIcons/camera-panorama-svgrepo-com.svg').default
const copyCoordsButtonIconSrc = require('../../../../assets/images/icons/save_geo_icon.png')

const navigateToMapButtonIconSrc = getIndorImageSrc(IndorImages.Map);
const mapSettingsButtonIconSrc = getIndorImageSrc(IndorImages.MapLayers);
const searchLineButtonIconSrc = getIndorImageSrc(IndorImages.MapNavigateZoom);

export default function ContentHeaderPanoramaWidgets() {

    const navigate = useNavigate()
    const [windowIsSmall, setWindowIsSmall] = useState(false);
    const { copyCoordsButtonIsClicked, searchLineIsShown } = useAppSelector(state => state.contentHeader)

    const sideBarIsShown = useAppSelector(state => state.sidebar.sidebarIsShown)
    useEffect(() => {
        const contentHeaderWidth: any = document.querySelector('.content-header-div')?.getBoundingClientRect().width;
        setWindowIsSmall(contentHeaderWidth < 900)
    }, [sideBarIsShown, navigate])

    const widgetsConfigArray = [
        {
            visible: windowIsSmall,
            name: "Настройки панорамы",
            imageSrc: panoramaFilterButtonIconSrc,
            onClick: () => controlPanoramaFilterButton(navigate)
        },
        {
            name: "На карту",
            imageSrc: navigateToMapButtonIconSrc,
            onClick: () => controlNavigateToMapButton(navigate)
        },
        {
            name: "Настройки карты",
            imageSrc: mapSettingsButtonIconSrc,
            onClick: () => controlMapSettingsButton(navigate)
        },
        {
            active: copyCoordsButtonIsClicked,
            name: "Скопировать координаты в буфер обмена",
            imageSrc: copyCoordsButtonIconSrc,
            onClick: controlCopyCoordsButton
        },
        {
            active: searchLineIsShown,
            name: "Поиск",
            imageSrc: searchLineButtonIconSrc,
            onClick: controlSearchLineButton
        }
    ]

    return (
        <>
            {!windowIsSmall &&
                <PanoramaFilters type="header" />
            }
            {
                widgetsConfigArray.map((contentHeaderMapWidget: any) => {
                    const { visible, name, active, imageSrc, onClick } = contentHeaderMapWidget ?? {}
                    const buttonIsVisible = ('visible' in contentHeaderMapWidget && visible) || !('visible' in contentHeaderMapWidget)
                    if (buttonIsVisible) {
                        return (
                            <ContentHeaderButton
                                key={name}
                                active={active}
                                imageSrc={imageSrc}
                                name={name}
                                onClick={onClick}
                            />
                        )
                    }
                })
            }
        </>
    )
}